const center="center-center"
const ngxUiLoaderConfig: NgxUiLoaderConfig =
{
    "bgsColor": "red",
    "bgsOpacity": 0.5,
    "bgsPosition": "bottom-right",
    "bgsSize": 60,
    "bgsType": "ball-spin-clockwise",
    "blur": 5,
    "delay": 0,
    "fastFadeOut": true,
    "fgsColor": "red",
    "fgsPosition": center,
    "fgsSize": 60,
    "fgsType": "ball-spin-clockwise",
    "gap": 24,
    "logoPosition": center,
    "logoSize": 120,
    "logoUrl": "",
    "masterLoaderId": "master",
    "overlayBorderRadius": "0",
    "overlayColor": "rgba(40, 40, 40, 0.8)",
    "pbColor": "red",
    "pbDirection": "ltr",
    "pbThickness": 3,
    "hasProgressBar": true,
    "text": "",
    "textColor": "#FFFFFF",
    "textPosition": center,
    "maxTime": -1,
    "minTime": 300
};
import { InjectionToken, NgModule , provideAppInitializer ,inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './core/header/header.component';
import { ToolbarComponent } from './core/toolbar/toolbar.component';
import { FooterComponent } from './core/footer/footer.component';

// for dropdowns, any animations in web etc
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';

// mat list,icon,menu
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { AgGridModule } from 'ag-grid-angular';
import { HomeComponent } from './pages/home/home.component';
import { LiosNavbarComponent } from './core/lios-navbar/lios-navbar.component';


//Msal
import { MsalService, MSAL_INSTANCE, MsalGuard, MsalInterceptor, MsalBroadcastService } from './msal';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG } from './msal/constants';
import { MsalInterceptorConfig } from './msal/msal.interceptor.config';
import { environment } from 'src/environments/environment';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { ConstantsService } from './service/constants.service';
import { Constants } from './constants';
import { NotificationMessageComponent } from './pages/notification-message/notification-message.component';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { BtnCellRendererEditDelete } from './core/grid/btn-cell-render-edit-delete';
import { BtnCellRendererDetailsSupplier } from 'src/app/core/grid/btn-cell-render-details-supplier';
import { InvestigationComponent } from './pages/investigation/investigation/investigation.component';
import { EditInvestigationComponent } from './core/dialogs/edit-investigation/edit-investigation.component';
import { PlanVersusActualComponent } from './pages/plan-versus-actual/plan-versus-actual.component';
import { PlanVersusActualSupplierComponent } from './pages/plan-versus-actual/plan-versus-actual-supplier/plan-versus-actual-supplier.component';
import { PlanVersusActualDockComponent } from './pages/plan-versus-actual/plan-versus-actual-supplier/plan-versus-actual-dock/plan-versus-actual-dock.component';
import { PlanVersusActualPartNumberComponent } from './pages/plan-versus-actual/plan-versus-actual-supplier/plan-versus-actual-dock/plan-versus-actual-part-number/plan-versus-actual-part-number.component';
import { BtnCellRendererDetails } from './core/grid/btn-cell-render-details';
import { BtnCellRendererDetailsDock } from './core/grid/btn-cell-render-details-dock';
import { BtnCellRendererDeleteClipboard } from './core/grid/btn-cell-render-delete ';
import { ImportTemplateComponent } from './core/dialogs/import-template/import-template.component';
import { DeleteDialogComponent } from './core/dialogs/delete-dialog/delete-dialog.component';
import { AddHomeComponent } from './core/dialogs/add-home/add-home.component';
import { reasonIdComponent } from './pages/masterSettings/reason-id/reason-id.component';
import { DailyexpediteComponent } from './pages/masterSettings/daily-expedite/daily-expedite.component';
import { RootCauseComponent } from './pages/masterSettings/root-cause/root-cause.component';
import { AddReasonIdComponent } from './core/dialogs/add-reason-id/add-reason-id.component';
import { AddRootCauseComponent } from './core/dialogs/add-root-cause/add-root-cause.component';
import { HistoryLogsComponent } from './core/dialogs/history-logs/history-logs.component';
import { AddDailyExpediteComponent } from './core/dialogs/add-daily-expedite/add-daily-expedite.component';
import { CopyTierDialogComponent } from './core/dialogs/copy-tier-dialog/copy-tier-dialog.component';
import { HistoryComponent } from './pages/history/history.component';
import { PeriodDropdownComponent } from './pages/period-dropdown/period-dropdown.component';
import { RunReportComponent } from './core/dialogs/run-report/run-report.component';
import { ReportDownloadComponent } from './core/dialogs/report-download/report-download.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { FgaModule } from './fga/fga.module';
import { CommonModule } from '@angular/common';

import { FgaService } from './fga/fga.service';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { provideApollo } from 'apollo-angular';
import { InMemoryCache } from '@apollo/client/cache';
import {
    MsalInterceptorConfiguration,
    MsalGuardConfiguration,
  } from '@azure/msal-angular';
  import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import { AddParamsInterceptor } from './add-params.interceptor';
import { BreadcrumbComponent } from './core/breadcrumb/breadcrumb.component';
    
  ModuleRegistry.registerModules([ AllCommunityModule ]);
export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: environment.CLIENT_ID,
            authority: environment.TENANT_ID,
            redirectUri: environment.REDIRECT_URL
        }
    });
}



export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set(
      environment.REDIRECT_URL,
      environment.SCOPES
    );
  
    return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap,
    };
  }

  export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [...environment.SCOPES],
      },
      loginFailedRoute: '/unauthorized',
    };
  }

  export function initializeMsal(instance: IPublicClientApplication): () => Promise<void> {
    return () => instance.initialize();
}



// export const FGA_API_ENDPOINT = new InjectionToken<string>('FGA_API_ENDPOINT');
import { FGA_API_ENDPOINT } from './fga/fa-api.token';



@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        ToolbarComponent,
        FooterComponent,
        HomeComponent,
        LiosNavbarComponent,
        BtnCellRendererEditDelete,
        NotificationMessageComponent,
        InvestigationComponent,
        EditInvestigationComponent,
        PlanVersusActualComponent,
        PlanVersusActualSupplierComponent,
        PlanVersusActualDockComponent,
        PlanVersusActualPartNumberComponent,
        BtnCellRendererDetails,
        BtnCellRendererDeleteClipboard,
        BtnCellRendererDetailsSupplier,
        BtnCellRendererDetailsDock,
        ImportTemplateComponent,
        DeleteDialogComponent,
        AddHomeComponent,
        reasonIdComponent,
        DailyexpediteComponent,
        RootCauseComponent,
        AddReasonIdComponent,
        AddRootCauseComponent,
        HistoryLogsComponent,
        HistoryComponent,
        AddDailyExpediteComponent,
        CopyTierDialogComponent,
        PeriodDropdownComponent,
        RunReportComponent,
        ReportDownloadComponent,
        UnauthorizedComponent
    ],
    bootstrap: [AppComponent], imports: [
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        AppRoutingModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatDialogModule,
        BrowserAnimationsModule,
        AgGridModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        NgxMatSelectSearchModule,
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        MatTabsModule,
        FgaModule,
        CommonModule,
        BreadcrumbComponent], providers: [ConstantsService, Constants, DatePipe,
            {
                provide: HTTP_INTERCEPTORS,
                useClass: MsalInterceptor,
                multi: true
            },
             {
                provide: HTTP_INTERCEPTORS,
                useClass: AddParamsInterceptor,
                multi: true
            },
            {
                provide: MSAL_INSTANCE,
                useFactory: MSALInstanceFactory
            },
            provideAppInitializer(() => {
                const msalInstance = inject(MSAL_INSTANCE);
                return msalInstance.initialize();
              }),
            {
                provide: MSAL_GUARD_CONFIG,
                useFactory: MSALGuardConfigFactory
            },
            {
                provide: MSAL_INTERCEPTOR_CONFIG,
                useFactory: MSALInterceptorConfigFactory
            },
            MsalService,
            MsalGuard,
            MsalBroadcastService, provideHttpClient(withInterceptorsFromDi()),
            provideApollo(() => {
                return { cache: new InMemoryCache() };
              }),
            { provide: FGA_API_ENDPOINT, useValue: environment.APM_DS_URI }
        ]
})
export class AppModule { }
